import axios from 'axios';
import store, { stopLoading } from 'actions';
import { Alerts } from 'utilities';
import { URL } from 'config/settings';

const httpClient = axios.create({ baseURL: URL });

httpClient.interceptors.request.use(
    async (config) => {
        const tokenStorage = localStorage.getItem('token') ?? ''
        config.headers = { ...(tokenStorage && { Authorization: tokenStorage }) }
        return config
    },
    (error) => { Promise.reject(error) }
)

httpClient.interceptors.response.use(
    function (response) { return response },
    function (error) {
        const errorMessage = error?.response?.data?.message;
        if (errorMessage) {
            store.dispatch(stopLoading())
            Alerts.error({ text: errorMessage })
        }
        return Promise.reject(error)
    });

export default httpClient;
